module.exports = __webpack_public_path__ + "media/21.625c1cf5.mp3";